import Vue from "vue";
import Router from "vue-router";
import Index from "@/pages/index"; //首页

const routes = [
  // 首页
  {
    path: "/",
    component: Index,
    name: "indexBox",
    meta: {
      title: ""
    },
    keepAlive: true
  },
  {
    path: "/appointment/20230203",
    component: () => import("@/pages/appointment/20230203"),
    name: "appointment.20230203",
    meta: {
      title: "宝宝教育规划"
    }
  },
  {
    path: "/appointment/20230324",
    component: () => import("@/pages/appointment/20230324"),
    name: "appointment.20230324",
    meta: {
      title: "1对1规家庭保障方案"
    }
  },
  {
    path: "/appointment/20230103",
    component: () => import("@/pages/appointment/20230103"),
    name: "appointment.20230103",
    meta: {
      title: "保险方案1对1定制"
    }
  },
  {
    path: "/appointment/20221123",
    component: () => import("@/pages/appointment/20221123"),
    name: "appointment.20221123",
    meta: {
      title: "1对1资产配置实操"
    }
  },
  {
    path: "/appointment/20220609",
    component: () => import("@/pages/appointment/20220609"),
    name: "appointment.20220609",
    meta: {
      title: "0元定制全家保障方案"
    }
  },
  {
    path: "/appointment/20220526",
    component: () => import("@/pages/appointment/20220526"),
    name: "appointment.20220526",
    meta: {
      title: "2022超牛重疾险"
    }
  },
  {
    path: "/appointment/20220516",
    component: () => import("@/pages/appointment/20220516"),
    name: "appointment.20220516",
    meta: {
      title: "资产配置实操帮您实现财富稳增长"
    }
  },
  {
    path: "/appointment/20220505",
    component: () => import("@/pages/appointment/20220505"),
    name: "appointment.20220505",
    meta: {
      title: "且慢私人定制资产配置方案"
    }
  },
  {
    path: "/appointment/20220428",
    component: () => import("@/pages/appointment/20220428"),
    name: "appointment.20220428",
    meta: {
      title: "福利来袭"
    }
  },
  {
    path: "/appointment/20220418",
    component: () => import("@/pages/appointment/20220418"),
    name: "appointment.20220418",
    meta: {
      title: "更懂你的定期寿险，凭手机号免费测算"
    }
  },
  {
    path: "/appointment/20220411",
    component: () => import("@/pages/appointment/20220411"),
    name: "appointment.20220411",
    meta: {
      title: "0元定制全家保障方案"
    }
  },
  {
    path: "/appointment/20220407",
    component: () => import("@/pages/appointment/20220407"),
    name: "appointment.20220407",
    meta: {
      title: "2022超牛重疾险"
    }
  },
  {
    path: "/appointment/20220401/:type?",
    component: () => import("@/pages/appointment/20220401"),
    name: "appointment.20220401",
    meta: {
      title: "1对1定制全家保障方案"
    }
  },
  {
    path: "/appointment/20220331",
    component: () => import("@/pages/appointment/20220331"),
    name: "appointment.20220331",
    meta: {
      title: "0元定制全家保障方案"
    }
  },
  {
    path: "/appointment/20220323",
    component: () => import("@/pages/appointment/20220323"),
    name: "appointment20220323",
    meta: {
      title: "小小见面礼，送宝宝最贴心的守护"
    }
  },
  {
    path: "/appointment/20220315",
    component: () => import("@/pages/appointment/20220315"),
    name: "appointment20220315",
    meta: {
      title: "0元定制全家保障方案"
    }
  },
  {
    path: "/appointment/20220301",
    component: () => import("@/pages/appointment/20220301"),
    name: "appointment20220301",
    meta: {
      title: "0元定制全家保障方案"
    }
  },
  {
    path: "/appointment/20220207a",
    component: () => import("@/pages/appointment/20220207aNew"),
    name: "appointment20220207a",
    meta: {
      title: "2023年家庭资产规划"
    }
  },
  {
    path: "/appointment/20231129a",
    component: () => import("@/pages/appointment/20231129aNew"),
    name: "appointment20231129a",
    meta: {
      title: "2023年家庭资产规划"
    }
  },
  {
    path: "/appointment/20220207",
    component: () => import("@/pages/appointment/20220207"),
    name: "appointment20220207",
    meta: {
      title: "2022年人气重疾险"
    }
  },
  {
    path: "/appointment/20220207Success",
    component: () => import("@/pages/appointment/20220207Success"),
    name: "20220207Success",
    meta: {
      title: "提交成功"
    }
  },
  {
    path: "/appointment/20220113",
    component: () => import("@/pages/appointment/20220113"),
    name: "appointment20220113",
    meta: {
      title: "万一得了癌症，新农合能报销多少？"
    }
  },
  {
    path: "/appointment/20211222",
    component: () => import("@/pages/appointment/20211222"),
    name: "appointment20211222",
    meta: {
      title: "1V1家庭资产方案规划"
    }
  },
  {
    path: "/appointment/20211222Success",
    component: () => import("@/pages/appointment/20211222Success"),
    name: "20211222Success",
    meta: {
      title: "提交成功"
    }
  },
  {
    path: "/appointment/20220207Success",
    component: () => import("@/pages/appointment/20220207Success"),
    name: "20220207Success",
    meta: {
      title: "提交成功"
    }
  },
  {
    path: "/appointment/20211215",
    component: () => import("@/pages/appointment/20211215"),
    name: "appointment20211215",
    meta: {
      title: "冬日暖心福利"
    }
  },
  {
    path: "/appointment/success20211215",
    component: () => import("@/pages/appointment/20211215Success"),
    name: "appointmentSuccess20211215",
    meta: {
      title: "提交成功"
    }
  },
  {
    path: "/appointment/20211206",
    component: () => import("@/pages/appointment/20211206"),
    name: "appointment20211206",
    meta: {
      title: "一对一专属保险顾问"
    }
  },
  {
    path: "/appointment/20211105",
    component: () => import("@/pages/appointment/20211105"),
    name: "appointment20211105",
    meta: {
      title: "小小见面礼，送宝宝最贴心的守护"
    }
  },
  {
    path: "/appointment/success20211105",
    component: () => import("@/pages/appointment/20211105Success"),
    name: "appointmentSuccess20211105",
    meta: {
      title: "预约成功"
    }
  },
  {
    path: "/appointment/20211013",
    component: () => import("@/pages/appointment/20211013"),
    name: "appointment20211013",
    meta: {
      title: "抗击两癌疾病，守护女性健康"
    }
  },
  {
    path: "/appointment/20210923",
    component: () => import("@/pages/appointment/20210923"),
    name: "appointment20210923",
    meta: {
      title: "利多多增额终身寿险重磅上线，利率不变，最快4年回本"
    }
  },
  {
    path: "/appointment/20210922a",
    component: () => import("@/pages/appointment/20210922a"),
    name: "appointment20210922a",
    meta: {
      title: "预约顾问"
    }
  },
  {
    path: "/appointment/20210918",
    component: () => import("@/pages/appointment/20210918"),
    name: "appointment20210918",
    meta: {
      title: "妈咪保贝（新生版）全新升级，保额更高，保费更低！"
    }
  },
  {
    path: "/appointment/success20210918",
    component: () => import("@/pages/appointment/20210918Success"),
    name: "appointmentSuccess20210918",
    meta: {
      title: "预约成功"
    }
  },
  {
    path: "/appointment/20210922",
    component: () => import("@/pages/appointment/20210922"),
    name: "appointment20210922",
    meta: {
      title: "幸孕儿母婴保障计划，宝宝和妈妈双重保障！"
    }
  },

  {
    path: "/appointmentct",
    component: () => import("@/pages/appointment"),
    name: "appointmentct",
    meta: {
      title: ""
    }
  },
  {
    path: "/appointment/20210706",
    component: () => import("@/pages/appointment/20210706"),
    name: "appointment20210706",
    meta: {
      title: "简知钱米学员专属福利--免费咨询"
    }
  },
  {
    path: "/appointment/20210706Success",
    component: () => import("@/pages/appointment/20210706Success"),
    name: "appointment20210706Success",
    meta: {
      title: "预约成功"
    }
  },
  {
    path: "/appointment/20210702",
    component: () => import("@/pages/appointment/20210702"),
    name: "appointment20210702",
    meta: {
      title: "入群见面礼，最贴心的守护"
    }
  },
  {
    path: "/appointmentCustom",
    component: () => import("@/pages/appointmentCustom"),
    name: "appointmentCustom",
    meta: {
      title: ""
    }
  },
  {
    path: "/appointment/20210809",
    component: () => import("@/pages/appointment/20210809"),
    name: "appointmentService",
    meta: {
      title: "0元定制全家保障方案"
    }
  },
  {
    path: "/appointment/20211015",
    component: () => import("@/pages/appointment/20211015"),
    name: "appointmentServicess",
    meta: {
      title: ""
    }
  },
  {
    path: "/appointment/20210809Success",
    component: () => import("@/pages/appointment/20210809Success"),
    name: "appointmentServiceSuccess",
    meta: {
      title: ""
    }
  },
  {
    path: "/appointment/20210811",
    component: () => import("@/pages/appointment/20210811"),
    name: "appointment20210811",
    meta: {
      title: "0-17岁养娃必看！"
    }
  },
  {
    path: "/appointment/success20210811",
    component: () => import("@/pages/appointment/20210811Success"),
    name: "appointmentSuccess20210811",
    meta: {
      title: "预约成功"
    }
  },
  {
    path: "/appointmentCustom2",
    component: () => import("@/pages/appointmentCustom2"),
    name: "appointmentCustom2",
    meta: {
      title: ""
    }
  },
  {
    path: "/appointmentctSuccess",
    component: () => import("@/pages/appointmentctSuccess"),
    name: "AppointmentctSuccess",
    meta: {
      title: ""
    }
  },
  {
    // 所有产品
    path: "/allProduct",
    name: "AllProduct",
    component: () => import("@/pages/allProduct"),
    meta: {
      title: ""
    }
  },
  {
    // 所有产品
    path: "/policyDetails",
    name: "policyDetails",
    component: () => import("@/pages/policyDetails"),
    meta: {
      title: "理赔详情"
    }
  },
  {
    // 搜索结果
    path: "/searchList",
    name: "SearchList",
    component: () => import("@/pages/searchList"),
    meta: {
      title: ""
    }
  },
  {
    path: "/queryPolicy",
    name: "QueryPolicy",
    component: () => import("@/pages/queryPolicy"),
    meta: {
      title: "查询保单"
    }
  },
  {
    // 无忧理赔
    path: "/claimPic",
    name: "ClaimPic",
    component: () => import("@/pages/claimPic"),
    meta: {
      title: "无忧理赔"
    }
  },
  {
    // 查询保单
    path: "/queryClaimPolicy/:pageType",
    name: "QueryClaimPolicy",
    component: () => import("@/pages/queryClaimPolicy"),
    meta: {
      title: "查询保单"
    }
  },
  {
    // 我的理赔
    path: "/myClaims",
    name: "MyClaims",
    component: () => import("@/pages/myClaims"),
    meta: {
      title: "我的理赔"
    }
  },
  {
    // 我的保单
    path: "/myPolicy",
    name: "MyPolicy",
    component: () => import("@/pages/myPolicy"),
    meta: {
      title: "我的保单"
    }
  },
  {
    // 申请理赔
    path: "/applyClaims",
    name: "ApplyClaims",
    component: () => import("@/pages/applyClaims"),
    meta: {
      title: "申请理赔"
    }
  },
  {
    // 填写理赔信息
    path: "/claimsMsg",
    name: "ClaimsMsg",
    component: () => import("@/pages/claimsMsg"),
    meta: {
      title: "填写理赔信息"
    }
  },
  {
    // 填写预约顾问信息
    path: "/appointment",
    name: "Appointment",
    component: () => import("@/pages/appointment"),
    meta: {
      title: " "
    }
  },
  {
    // 填写预约顾问信息 简知定制 通用
    path: "/appointment/mg",
    name: "AppointmentMG",
    component: () => import("@/pages/appointment/mg"),
    meta: {
      title: " "
    }
  },
  {
    // 填写预约顾问信息 简知定制 通用
    path: "/appointment/jz",
    name: "AppointmentJz",
    component: () => import("@/pages/appointment/jz"),
    meta: {
      title: " "
    }
  },
  {
    // 填写预约顾问信息 简知定制 年金
    path: "/appointment/jznj",
    name: "AppointmentJznj",
    component: () => import("@/pages/appointment/jznj"),
    meta: {
      title: " "
    }
  },
  {
    // 填写预约顾问信息
    path: "/appointment11",
    name: "Appointment11",
    component: () => import("@/pages/appointment11"),
    meta: {
      title: "免费预约顾问"
    }
  },
  {
    // 填写预约顾问信息
    path: "/appointmentsu11",
    name: "Appointmentsu11",
    component: () => import("@/pages/appointmentsu11"),
    meta: {
      title: "预约成功"
    }
  },
  {
    // 填写预约顾问信息
    path: "/appointmentSuccess",
    name: "AppointmentSuccess",
    component: () => import("@/pages/appointmentSuccess"),
    meta: {
      title: "预约成功"
    }
  }
];
const router = new Router({
  routes
});
Vue.use(Router);
router.beforeEach((to, from, next) => {
  if (navigator.general) {
    navigator.general.hideRightIcon();
  } else {
    document.addEventListener(
      "deviceready",
      function() {
        navigator.general.hideRightIcon();
      },
      false
    );
  }
  setTimeout(function() {
    document.getElementsByTagName("title")[0].innerText = to.meta.title;
  }, 100);
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js